module.exports = __webpack_public_path__ + "static/media/ic-order-active.a3c3e7e0.svg";